import * as React from 'react';
import { PageChorinitia } from '../genericComponents/Page/PageChorinitia';
import { UserRole } from '../../types/UserRole';
import { MediaManagmentList } from './internalComponents/MediaManagmentList';

interface State {
}

interface Props {
}

/**
 * le composant permet l'affichage de la page de gestion des medias
 */
export class ManageMediasPage extends React.Component {
    state: State;
    props: Props;

    constructor(props: Props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <PageChorinitia
                allowedUsers={[
                    UserRole.ADMIN,
                ]}
            >
                <MediaManagmentList/>
            </PageChorinitia>
        );
    }
} 


// WEBPACK FOOTER //
// ./src/components/MediasPage/ManageMediasPage.tsx